module.exports = __webpack_public_path__ + "img/sg-icon.efae5c24.png";